var path = 'public/app/plugins/datasource/graphite/partials/annotations.editor.html';
var html = "<div class=gf-form-group>\n  <div class=gf-form>\n    <span class=\"gf-form-label width-12\">Graphite query</span>\n    <input type=text class=gf-form-input ng-model=ctrl.annotation.target placeholder=\"Example: statsd.application.counters.*.count\">\n  </div>\n\n\t<h5 class=section-heading>Or</h5>\n\n  <div class=gf-form>\n    <span class=\"gf-form-label width-12\">Graphite events tags</span>\n    <input type=text class=gf-form-input ng-model=ctrl.annotation.tags placeholder=\"Example: event_tag_name\">\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./public/app/plugins/datasource/graphite/partials/annotations.editor.html
// module id = 1126
// module chunks = 3